import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import Box from '@material-ui/core/Box';

import { sqlDateToLabel } from 'helpers/helpers';
import compose from 'helpers/compose';

import CustomPaper from 'components/Layout/Background';
import GenerationDialog from 'components/GenerationDialog/GenerationDialog';

import { RootStore } from 'stores/rootStore';
import { MovementsStore } from 'stores/account/movementsStore';
import MovementsTable from './MovementsTable';
import MovementsFilter from './MovementsFilter';
import { AccountMode } from 'enums';


interface Props {
  rootStore: RootStore;
  accountId: string;
  mode: AccountMode;
}

const Movements: React.FC<Props> = ({ rootStore, accountId, mode }) => {
  const { t } = useTranslation();
  const [store] = useState(new MovementsStore(rootStore, accountId));

  useEffect(() => {
    store.fetchData();
  }, [store]);

  return store.data ? (
    <Container maxWidth="md">
      <CustomPaper>
        <Grid container>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h3">
              {t('accountDetail_movements_title')} {sqlDateToLabel(store.data.from, 'dd. MM. yyyy')}&#8202;—&#8202;
              {sqlDateToLabel(store.data.to, 'dd. MM. yyyy')}
            </Typography>
             <Button variant="outlined" startIcon={<GetAppIcon />} onClick={store.sendMovementCsv}>{t('accounts_download_csv_short')}</Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={3}>
            <MovementsFilter store={store} />
          </Grid>
          <Grid item sm={'auto'} md={1} />
          <Grid item xs={12} sm={8}>
            <MovementsTable store={store} mode={mode} />
          </Grid>
        </Grid>
      </CustomPaper>

      <GenerationDialog store={store} />

    </Container>
  ) : null;
};

export default compose(inject('rootStore'), observer)(Movements);
